import React from 'react';

const ArrowupIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.99999 12.8337V1.16699M6.99999 1.16699L1.16666 7.00033M6.99999 1.16699L12.8333 7.00033" stroke="#12B76A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>

);

export default ArrowupIcon;
